import cn from 'classnames';
import { ButtonWithIcon } from '@ui/button';
import { IWarehouseBagTemplateProps } from '..';
import styles from './styles.module.css';

export function WarehouseBagSleeveTemplate(props: IWarehouseBagTemplateProps) {
  const {
    className,
    image,
    cultureName,
    sleeveId = '',
    attention = false,
    borderColor = 'transparent',
    backgroundColor = 'transparent',
    params = [],
    actions = null,
    mixed = false,
    ...rest
  } = props;
  const rootClass = cn(className, styles.bag);

  return (
    <div className={rootClass} style={{ borderColor, backgroundColor }} {...rest}>
      {mixed && <div className={styles.addedToMix}>добавлено в бункер</div>}

      <div className={styles.data}>
        <div className={styles.img}>{image}</div>
        <div className={styles.header}>
          <span className={styles.title}>{cultureName}</span>
          <span className={styles.sleeveId}>{sleeveId}</span>
          {attention && (
            <ButtonWithIcon icon="Attention" className={styles.attention} />
          )}
        </div>
        <div className={styles.params}>{params}</div>
      </div>

      {actions}
    </div>
  );
}
